import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import StorefrontIcon from '@mui/icons-material/Storefront';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import { Box, Grid, Typography } from '@mui/material';
import { isEmpty } from 'lodash';
import WizardCard from 'pages/GettingStarted/Wizard/components/WizardCard';
import WizardPrimaryButton from 'pages/GettingStarted/Wizard/components/WizardPrimaryButton';
import WizardContentLayout from 'pages/GettingStarted/Wizard/Phases/WizardContentLayout';
import { WIZARD_PAGES } from 'pages/GettingStarted/Wizard/utils/consts';
import React, { FC } from 'react';
import { ArchType, IWizardProps, WizardMode, WizardPhase } from 'types/wizard';
import { useWizardUpdate } from '../../utils/hook';

const ArchTypePage: FC<IWizardProps> = ({ state }) => {
	const { archType } = state;

	const [selected, setSelected] = React.useState(archType);
	const { update } = useWizardUpdate(state);

	const handleNext = React.useCallback(async () => {
		update({
			mode: WizardMode.inProgress,
			phase: WizardPhase.Build,
			archType: selected,
			page: WIZARD_PAGES.primaryMethods
		});
	}, [update, selected]);

	return (
		<WizardContentLayout
			{...{ state }}
			actionButton={
				<WizardPrimaryButton
					disabled={isEmpty(selected)}
					onClick={handleNext}
				/>
			}
		>
			<Box
				display="flex"
				flexDirection="column"
				flexGrow={1}
				data-testid="wizard-arch-type"
			>
				<Box display="flex" flexDirection="column" flexGrow={6}>
					<Typography variant="h6">
						{intl.tr('wizard.phase.build.arch.question')}
					</Typography>
					<Grid container spacing={4} pb={6} pt={4}>
						<Grid item>
							<WizardCard
								label={intl.tr('wizard.phase.build.arch.businesses')}
								Icon={StorefrontIcon}
								selected={selected === ArchType.MT}
								onClick={() => {
									setSelected(ArchType.MT);
								}}
								size="large"
							/>
						</Grid>
						<Grid item>
							<WizardCard
								label={intl.tr('wizard.phase.build.arch.consumers')}
								Icon={SupervisorAccountIcon}
								selected={selected === ArchType.B2C}
								onClick={() => setSelected(ArchType.B2C)}
								size="large"
							/>
						</Grid>
					</Grid>
					{selected && (
						<Box display="flex" flexDirection="row" flexGrow={1}>
							<HelpOutlineIcon color="disabled" />
							<Typography variant="body1" pl={1}>
								{intl.tr(`wizard.phase.build.arch.info.${selected}`)}
							</Typography>
						</Box>
					)}
				</Box>
			</Box>
		</WizardContentLayout>
	);
};

export default ArchTypePage;
